export default "__VITE_ASSET__WmVheN65IJB9uXYia7eaQQ__"